import React, { createContext, useState, useContext, useEffect } from 'react';

const ModeContext = createContext();

export const ModeProvider = ({ children }) => {
  // Mode: 'AP' or 'TYT'
  const [mode, setMode] = useState(() => {
    return localStorage.getItem('bridgeprep_mode') || 'TYT';
  });

  useEffect(() => {
    localStorage.setItem('bridgeprep_mode', mode);
  }, [mode]);

  const toggleMode = () => {
    setMode(prevMode => prevMode === 'AP' ? 'TYT' : 'AP');
  };

  const switchToMode = (newMode) => {
    if (newMode === 'AP' || newMode === 'TYT') {
      setMode(newMode);
    }
  };

  // Mode characteristics
  const modeConfig = {
    AP: {
      name: 'AP Mode',
      description: 'Deep conceptual understanding with FRQ, justification, CER',
      language: 'en',
      questionTypes: ['MCQ', 'FRQ', 'CER'],
      focus: 'conceptual_depth',
      timePerQuestion: 180, // 3 minutes
      color: 'blue',
      icon: '🌍',
      features: {
        frq: true,
        cer: true,
        justification: true,
        englishTerminology: true,
        detailedExplanations: true,
        apStandards: true
      }
    },
    TYT: {
      name: 'TYT Modu',
      description: 'Hız, test stratejisi, işlem pratiği',
      language: 'tr',
      questionTypes: ['MCQ'],
      focus: 'speed_accuracy',
      timePerQuestion: 90, // 1.5 minutes
      color: 'red',
      icon: '🇹🇷',
      features: {
        quickSolutions: true,
        testTactics: true,
        speedDrills: true,
        turkishTerminology: true,
        practiceOriented: true,
        yksStandards: true
      }
    }
  };

  const currentConfig = modeConfig[mode];

  const value = {
    mode,
    toggleMode,
    switchToMode,
    config: currentConfig,
    isAP: mode === 'AP',
    isTYT: mode === 'TYT'
  };

  return (
    <ModeContext.Provider value={value}>
      {children}
    </ModeContext.Provider>
  );
};

export const useMode = () => {
  const context = useContext(ModeContext);
  if (!context) {
    throw new Error('useMode must be used within ModeProvider');
  }
  return context;
};

export default ModeContext;
